<div class="image-box">
  <div class="image-header">
    Scanned Image
  </div>

  @if (showNoData) {
    <div
      class="eca-no-data-centered">
      <img src="assets/nothing-to-display-no-text.png">
      <div>
        No Data to Display
      </div>
    </div>
  }

  @else if (currentImageSource) {
    <div class="image-body"
      >
      <eca-zoom (events)="onZoomEvent($event)">
        <img #formImage
          class="form-image"
          [class.zoomed]="isZoomed"
          [src]="currentImageSource"
          [hidden]="loading"
          (load)="onImageLoad()"
          (error)="onImageError()"
          alt="Scanned Image">
        </eca-zoom>
        @for (overlayBox of overlayBoxes; track $index) {
          <div
            class="overlay"
            [style.opacity]="+!isZoomed"
            tabindex="-1"
         [ngStyle]="{
         'left': overlayBox.x + 'px',
         'top': overlayBox.y + 'px',
         'width': overlayBox.width + 'px',
         'height': overlayBox.height + 'px'
       }">
          </div>
        }
      </div>
    }

  </div>
